import type { UserMfaDetailsApi, UserApi } from 'api-typings/users/users';
import type { UsersMfa, UserMfaDetails } from './users-mfa.model';

/**
 * This transforms a usersSelf GET request with the projections set.
 */
export function transformUsersSelfMfa(user: UserApi): UsersMfa {
  return {
    id: user.id,
    mfa: user.mfa ? transformMfaDetails(user.mfa) : undefined,
  };
}

export function transformMfaDetails(
  mfaMfaDetails: UserMfaDetailsApi,
): UserMfaDetails {
  return {
    availableMethods: mfaMfaDetails.available_methods,
    preferredMethod: mfaMfaDetails.preferred_method,
  };
}
